import {
    Log, 
    LogLevel
} from 'one-log';

import {
    init
} from 'one-app';

import {
    loader
} from 'one-web-loader';

import {
    BrowserLogger
} from 'one-web-logger';

import { HAServer } from 'one-server-local-ha';

// if we would like to remove all unneccessary console.logs
// console.log = console.warn = console.error = () => {};

// set up the logger
const log = new Log(
    'sso-app', 
    [
        new BrowserLogger()
    ], 
    LogLevel.DEBUG
);


loader({
    log,
    url: 'settings.json',
}, (options: any) => (
    new Promise(async (resolve) => {
        const {
            settings,
            resolver,
        } = options;

        const { logconfig } = settings;
        if(logconfig?.level === 'INFO'){
            log.setlevel(LogLevel.INFO);
        } else  if(logconfig?.level === 'WARN'){
            log.setlevel(LogLevel.WARN);
        } else  if(logconfig?.level === 'ERROR'){
            log.setlevel(LogLevel.ERROR);
        } else{
            log.setlevel(LogLevel.DEBUG);
        }

        log.debug(
            'one-starterkit-web',
            'app settings', {
            settings,
        });

        // initialize the app
        const {
            store,
        } = await init('app', {
            log,
            settings,
            resolver,
            server: new HAServer(
                settings['servers']
            )
        });
        
        resolve({
            log,
            next: (params: any) => {
                // next is optional
                console.debug(
                    'one-starterkit-web',
                    'finished initialization...', {
                    params,
                });
                return Promise.resolve({ store });
            },
        });

    })
));
